import { useQuery } from 'react-query';
import api from '@/apis/utils';
import { AxiosError } from 'axios';
import GlobalAlert from '@/components/GlobalAlert';
import { getErrorMessage } from '@/utils/error';

/** [은행] 은행리스트 조회 */
export const useBanksQuery = () => {
  return useQuery(['banks'], () => api.getBanks(), {
    onError: (err: AxiosError) => {
      GlobalAlert.show({ title: getErrorMessage(err) });
    }
  });
};
